import React, { useState } from "react";

import Toolbar from "../../../../components/tasklayout/toolbar/Toolbar";
import Viewbar from "../../../../components/tasklayout/toolbar/features/viewbar/Viewbar";
import Buttons from "../../../../components/ui/button/Buttons";
import SidebarModel from "../../../../components/ui/sidebarModel/SidebarModel";
import { getCardInfo } from "../../../../lib/getCardInfo";
import CreateTask from "../../../task/CreateTask";
import { TaskPageEnums } from "../../../../utils/Enums/TaskPageEnums";
import { useTaskFilter } from "../../../../utils/Context/TaskFilterContext";
import useProjectTaskList from "../../hooks/useProjectTaskList";

const MyProjectsBacklog = () => {
  const { resetFilters } = useTaskFilter();
  const [showCreateModal, setShowCreateModal] = useState(false);

  const {
    projectId,
    cardData,
    taskList,
    showCompleted,
    hasMore,
    totalCount,
    isInitialLoad,
    isRefreshing,
    isLoadingMore,
    hasActiveFilters,
    hasActiveSearch,
    isError,
    onToggleChange,
    onSearchChange,
    handleRefreshGrid,
    handleLoadMore,
    handleRetry,
    patchTask,
  } = useProjectTaskList({
    getExtraFilter: ({ projectId: currentProjectId }) => ({
      Field: "ProjectId",
      Operator: "Is",
      Value: currentProjectId?.toString() || "0",
    }),
  });

  const handleCloseCreateModal = () => {
    setShowCreateModal(false);
    handleRefreshGrid();
  };

  return (
    <div className="myprojects-backloglist center-top-space">
      {cardData?.length > 0 && (
        <div className="card-section-info">
          {getCardInfo(cardData)}
        </div>
      )}
      <div className="task-layout">
        <div className="d-flex justify-content-end mb-2">
          <Buttons
            buttonTypeClassName="theme-btn"
            onClick={() => setShowCreateModal(true)}
            buttonText="Task"
            textWithIcon={true}
            fontIcon={true}
            iconName="material-symbols:add-rounded"
          />
        </div>
        <div>
          <Viewbar
            projectId={projectId}
            showCompleted={showCompleted}
            onToggleChange={onToggleChange}
            onSearchChange={onSearchChange}
            taskFilterPageId={TaskPageEnums.BACKLOG_TASK}
          />
        </div>
        <div className="task-layout-toolbar">
          <Toolbar
            projectId={projectId}
            taskListData={taskList}
            isTeamPlanning={false}
            allowEditStatus={true}
            allowEditAssignee={true}
            isShowActualTime={false}
            isDataLoading={isInitialLoad}
            isRefreshing={isRefreshing}
            isError={isError}
            onRetry={handleRetry}
            onClearFilters={resetFilters}
            hasActiveFilters={hasActiveFilters}
            hasActiveSearch={hasActiveSearch}
            onRefreshGrid={handleRefreshGrid}
            onLoadMoreTasks={handleLoadMore}
            isLoadingMore={isLoadingMore}
            hasMore={hasMore}
            totalCount={totalCount}
            onTaskPatch={patchTask}
          />
        </div>
      </div>
      {showCreateModal && (
        <SidebarModel
          isOpen={showCreateModal}
          onClose={handleCloseCreateModal}
          modalTitle="Create Task"
          modalSize="w-50"
          backdropClosable={false}
        >
          <CreateTask
            projectId={projectId}
            typeId={1}
            onClose={handleCloseCreateModal}
          />
        </SidebarModel>
      )}
    </div>
  );
};

export default MyProjectsBacklog;
